import getLabel from './get-label';
export default getLabel;
